// Set background gradient to closest image height divided by two, + 15px 

// To-do; target '.split-background-target' class instead of nearest image, fire on resize as well as page load
function splitBackground() {
	$(".split-background").each(function() {
		var distanceFromStart = $(this).closest('.split-background').find(".split-background-target").offset().top - $(this).closest('.split-background').offset().top;
		var targetHeight = $(this).closest('.split-background').find(".split-background-target").outerHeight() / 2;
	    var backgroundHeight = distanceFromStart + targetHeight - '2';

	    // console.log('// Stats for this .split-background iteration');
	    // console.log('distanceFromStart = ' + distanceFromStart);
		// console.log('targetHeight = ' + targetHeight);
	    // console.log('backgroundHeight = ' + backgroundHeight);

		$(this).closest('.split-background').attr('style','background: linear-gradient( to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) '+backgroundHeight+'px, #eeeeef '+backgroundHeight+'px, #eeeeef 100% );');

		$(this).find('.border-bottom').each(function(){
	    	var borderElementOffset = $(this).outerHeight();

	    	var borderElementMarginTop = targetHeight - borderElementOffset;

			$(this).attr('style','margin-top: '+borderElementMarginTop+'px;');

			// console.log('// --> Stats for this .border-bottom iteration');
			// console.log('borderElementHeight = ' + borderElementMarginTop);
		});
	});
}